import i18next from 'i18next';
import React from 'react';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import NonSalesConsumptionModal from '@admin/stores/StoreDetailsModules/StoreBufferStocks/utils/NonSalesConsumptionModal';

export const getNonSalesConsumptionModalConfig = ({
  ingredientUnit,
  handleNonSalesConsumptionModalSave,
  nonSalesConsumption,
  setModalConsumptionFrequency,
  setModalConsumptionQuantity,
  selectedIngredients,
  currency,
}) => ({
  type: 'action',
  width: '542px',
  height: 'auto',
  icon: '/images/inpulse/gear-ipblack-small.svg',
  title: i18next.t('ADMIN.STORES.MANAGE_NON_SALES_CONSUMPTION_ACTIONS'),
  component: () => (
    <NonSalesConsumptionModal
      currency={currency}
      ingredientUnit={ingredientUnit}
      nonSalesConsumption={nonSalesConsumption}
      setModalConsumptionFrequency={setModalConsumptionFrequency}
      setModalConsumptionQuantity={setModalConsumptionQuantity}
    />
  ),
  handleCloseCleanUp: () => {
    setModalConsumptionFrequency(null);
    setModalConsumptionQuantity(null);
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      isDisabled:
        !nonSalesConsumption || !nonSalesConsumption.frequency || nonSalesConsumption.quantity < 0,
      handleClick: () => handleNonSalesConsumptionModalSave(selectedIngredients),
    },
  ],
});
